export default {
  'filterByExternalUsers.title': 'Filtro Usuarios Externos',

  'filterByExternalUsers.form.valueSource': 'Origen Valor',

  'filterByExternalUsers.form': 'Formulario',
  'filterByExternalUsers.field': 'Campo',

  'filterByExternalUsers.form.variable': 'Variable',

  'filterByExternalUsers.form.form': 'Formulario',
  'filterByExternalUsers.form.field': 'Campo',
  'filterByExternalUsers.form.fixedValue': 'Valor Fijo',

  'filterByExternalUsers.form.select.FormField': 'Formulario / Campo',
  'filterByExternalUsers.form.select.Variable': 'Variable',
  'filterByExternalUsers.form.select.FixedValue': 'Valor Fijo',
};
